import LightSalesNav from '@/components/sales/LightSalesNav';
import LightHeroSection from '@/components/sales/LightHeroSection';
import HeroMediaSlideshow from '@/components/sales/HeroMediaSlideshow';
import LightProblemSection from '@/components/sales/LightProblemSection';
import LightAIToolsSection from '@/components/sales/LightAIToolsSection';
import LightSolutionSection from '@/components/sales/LightSolutionSection';
import LightTestimonialsSection from '@/components/sales/LightTestimonialsSection';
import LightPricingSection from '@/components/sales/LightPricingSection';
import AdditionalPricingBox from '@/components/sales/AdditionalPricingBox';
import LightFAQSection from '@/components/sales/LightFAQSection';
import LightSalesFooter from '@/components/sales/LightSalesFooter';
import LightExitPopup from '@/components/sales/LightExitPopup';
import MobileStickyBar from '@/components/sales/MobileStickyBar';
import SocialProofToast from '@/components/sales/SocialProofToast';
import CookieConsent from '@/components/CookieConsent';
import { Helmet } from 'react-helmet-async';
import auraMascotPoses from '@/assets/aura-mascot-poses.png';

const Index = () => {
  return (
    <>
      <Helmet>
        <title>Build Faceless Online Businesses With AI | Faceless Aura Club</title>
        <meta 
          name="description" 
          content="Learn how to build faceless YouTube channels, AI content pages, and automated online projects. Lessons, AI tools, and an AI mentor — all in one platform." 
        />
        <meta name="viewport" content="width=device-width, initial-scale=1, viewport-fit=cover" />
      </Helmet>
      
      <div className="min-h-screen bg-white">
        {/* Navigation */}
        <LightSalesNav />
        
        {/* Main sales funnel sections */}
        <main>
          <LightHeroSection />
          <HeroMediaSlideshow />
          <LightProblemSection />
          <LightAIToolsSection />
          <LightSolutionSection />
          <LightTestimonialsSection />
          <LightPricingSection />
          <AdditionalPricingBox />
          <LightFAQSection />
        </main>

        {/* Footer */}
        <LightSalesFooter />

        {/* Mobile sticky CTA bar */}
        <MobileStickyBar />

        {/* Social proof toast notifications */}
        <SocialProofToast />

        {/* Exit intent popup */}
        <LightExitPopup />

        {/* Cookie consent banner */}
        <CookieConsent />
      </div>
    </>
  );
};

export default Index;
